import * as React from 'react';

type InstagramProps = {
  width?: number;
  height?: number;
};

// tslint:disable:max-line-length
export const Instagram = (props: InstagramProps) => (
  <svg width={props.width || 16} height={props.height || 16} viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.098137 0H1.901863C.85143 0 0 .849685 0 1.8975v12.205C0 15.15075.85143 16 1.901863 16h12.196274C15.14857 16 16 15.15075 16 14.1025V1.8975C16 .849684 15.14857 0 14.098137 0zm-2.597932 2.500177c0-.276246.223877-.500122.499686-.500122h1.499933c.276245 0 .500122.223876.500122.500122V4.00011c0 .27581-.223877.500122-.500122.500122H11.99989c-.27581 0-.499685-.224313-.499685-.500123V2.500176zM8.018547 4.94886c1.69937 0 3.077108 1.37468 3.077108 3.069687 0 1.695443-1.377738 3.070125-3.077108 3.070125-1.698933 0-3.07667-1.374682-3.07667-3.070125 0-1.695006 1.377737-3.069688 3.07667-3.069688zm6.48152 9.051085c0 .276246-.223876.500123-.500122.500123H2.000055c-.276246 0-.500123-.223877-.500123-.500123v-7.49966h2.000054c-.260535.374875-.34869 1.074436-.34869 1.518262 0 2.67736 2.183783 4.855904 4.86725 4.855904 2.683906 0 4.867688-2.178544 4.867688-4.855903 0-.443826-.06328-1.132913-.38622-1.51826h2.000054v7.499658z'
      fill='#FFF'
      fillRule='evenodd'
    />
  </svg>  
);



// WEBPACK FOOTER //
// src/app/src/components/Icons/Instagram.tsx